// extracted by mini-css-extract-plugin
export default {"root":"RouteSettingsModal_root__vZYOW","switch":"RouteSettingsModal_switch__YNHPj"};